import { render, staticRenderFns } from "./ServiceGroupCreate.vue?vue&type=template&id=5790f2f7&"
import script from "./ServiceGroupCreate.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports